import Axios from "axios"
import { URL_POST_REPORT_TEAM_TODAY, URL_POST_REPORT_TEAM_TODAY_BY_CREATEDATE } from "../../config/DomainConfig"
import { getNumberFixed, getNumberWithCommas, getValWithPercentHtml } from "../UtilService"
import { getNorm, NORM_PROPERTIES } from "./PropertyConvertion"

const callTeamTodayReport = async (payload) => {
    let data = []
    const resp = await Axios.post(URL_POST_REPORT_TEAM_TODAY(), payload)
    // const resp = await Axios.get("/payload/team_today.json")

    if (resp && resp.data && resp.data.teamTodayEntities) {
        data = resp.data.teamTodayEntities
        data = getNorm(data, NORM_PROPERTIES)
        // data = buildHierarchy(resp.data.teamTodayEntities)
        // sumHierarchy(data)
        // calcHierarchy(data)
    }

    return { data: data, created: resp.data.created }
}
const callTeamTodayByCreatedateReport = async (payload) => {
    let data = []
    const resp = await Axios.post(URL_POST_REPORT_TEAM_TODAY_BY_CREATEDATE(), payload)

    if (resp && resp.data && resp.data.teamTodayByCreatedateEntities) {
        data = resp.data.teamTodayByCreatedateEntities
        data = getNorm(data, NORM_PROPERTIES)
        // data = buildHierarchy(resp.data.teamTodayByCreatedateEntities)
        // sumHierarchy(data)
        // calcHierarchy(data)
    }

    return { data: data, created: resp.data.created }
}

const buildHierarchy = (teamTodayByCreatedateEntities) => {
    let data = {}
    let teamId, teamName, cpCat, userId, cpId

    teamTodayByCreatedateEntities.forEach(row => {
        teamId = row.teamId ? row.teamId : 0
        teamName = row.teamName ? row.teamName : "No team"
        cpCat = row.cpCat
        userId = row.userId
        cpId = row.cpId

        if (!data[teamId]) {
            data[teamId] = {
                key: [teamId],
                name: teamName,
                cate: {}
            }
        }

        if (!data[teamId].cate[cpCat]) {
            data[teamId].cate[cpCat] = {
                key: [teamId, cpCat],
                name: row.cpCatName,
                campaign: {}
            }
        }

        if (!data[teamId].cate[cpCat].campaign[cpId]) {
            data[teamId].cate[cpCat].campaign[cpId] = {
                key: [teamId, cpCat, cpId],
                name: row.cpName,
                agent: []
            }
        }

        row.key = [teamId, cpCat, cpId, userId]
        row.name = (row.userName ? row.userName.split("@")[0] : "-")
        data[teamId].cate[cpCat].campaign[cpId].agent.push(row)
    })

    return data
}

const sumHierarchy = (data) => {
    // const sumFields = ["totalLead", "approved", "rejected"
    //     , "trash", "urgent", "delivered"
    //     , "callback", "uncall", "totalSoAmount"
    //     , "delivSaleOrder", "delivAmount"]
    let myFields
    let sumFields

    Object.keys(data).forEach(teamId => {
        Object.keys(data[teamId].cate).forEach(cpCat => {
            Object.keys(data[teamId].cate[cpCat].campaign).forEach(cpId => {
                if (!sumFields) {
                    myFields = Object.keys(data[teamId].cate[cpCat].campaign[cpId].agent[0])
                    sumFields = Object.keys(NORM_PROPERTIES).filter(fld => myFields.indexOf(fld) > -1).map(fld => NORM_PROPERTIES[fld])
                        .filter(fld => myFields.indexOf(fld) > -1)
                }
            })
        })
    })
        
    Object.keys(data).forEach(teamId => {
        sumFields.forEach(field => {
            data[teamId][field] = 0
        })

        Object.keys(data[teamId].cate).forEach(cpCat => {

            sumFields.forEach(field => {
                data[teamId].cate[cpCat][field] = 0
            })

            Object.keys(data[teamId].cate[cpCat].campaign).forEach(cpId => {

                sumFields.forEach(field => {
                    data[teamId].cate[cpCat].campaign[cpId][field] = 0
                })

                data[teamId].cate[cpCat].campaign[cpId].agent.forEach(ag => {

                    sumFields.forEach(field => {
                        data[teamId][field] += ag[field] ? ag[field] : 0
                        data[teamId].cate[cpCat][field] += ag[field] ? ag[field] : 0
                        data[teamId].cate[cpCat].campaign[cpId][field] += ag[field] ? ag[field] : 0
                    })
                })
            })
        })
    })
}

const calcHierarchy = (data) => {
    Object.keys(data).forEach(teamId => {

        calcHierarchyEle(data[teamId])

        Object.keys(data[teamId].cate).forEach(cpCat => {

            calcHierarchyEle(data[teamId].cate[cpCat])

            Object.keys(data[teamId].cate[cpCat].campaign).forEach(cpId => {

                calcHierarchyEle(data[teamId].cate[cpCat].campaign[cpId])

                data[teamId].cate[cpCat].campaign[cpId].agent.forEach(ag => {

                    calcHierarchyEle(ag)
                })
            })
        })
    })
}

const calcHierarchyEle = (_en) => {
    const _totalLead = _en.totalLead
    const _new = _en.new
    const _approved = _en.approved
    const _rejected = _en.rejected
    const _trash = _en.trash
    const _urgent = _en.urgent
    const _delivered = _en.delivered
    const _callback = _en.callback
    const _uncall = _en.uncall
    const _totalSoAmount = _en.totalSoAmount
    const _delivSaleOrder = _en.delivSaleOrder
    const _delivAmount = _en.delivAmount
    const _name = _en.name
    let _ear = _approved * 100 / (_approved + _rejected + _callback)
    let _aov = _totalSoAmount / _approved
    let _daov = _delivAmount / _delivSaleOrder

    _ear = isNaN(_ear) ? 0 : _ear
    _aov = isNaN(_aov) ? 0 : _aov
    _daov = isNaN(_daov) ? 0 : _daov

    _en["_name"] = { "__html": _name }
    _en["_leads"] = { "__html": getNumberWithCommas(_totalLead) + "" }
    _en["_sale"] = { "__html": getNumberWithCommas(_totalSoAmount) }
    _en["_new"] = { "__html": getValWithPercentHtml(_new, _totalLead) }
    _en["_approved"] = { "__html": getValWithPercentHtml(_approved, _totalLead) }
    _en["_ear"] = { "__html": getNumberFixed(_ear, 0) + "%" }
    _en["_aov"] = { "__html": getNumberFixed(_aov, 0) }
    _en["_rejected"] = { "__html": getValWithPercentHtml(_rejected, _totalLead) }
    _en["_callback"] = { "__html": getValWithPercentHtml(_callback, _totalLead) }
    _en["_uncall"] = { "__html": getValWithPercentHtml(_uncall, _totalLead) }
    _en["_trash"] = { "__html": getValWithPercentHtml(_trash, _totalLead) }
    _en["_urgent"] = { "__html": getValWithPercentHtml(_urgent, _totalLead) }
    _en["_deliver"] = { "__html": getValWithPercentHtml(_delivered, _totalLead) }
    _en["_dsale"] = { "__html": getNumberFixed(_delivAmount, 0) }
    _en["_dr"] = { "__html": getValWithPercentHtml(_delivSaleOrder, _approved) }
    _en["_daov"] = { "__html": getNumberFixed(_daov, 0) }
    _en["ear"] = _ear
    _en["aov"] = _aov
    _en["daov"] = _daov
}

const extractTeamCampaign = (ds, t0, sort, sortIdx) => {
    return Object.keys(ds[t0].cate).sort((ct1, ct2) => ct1 - ct2)
        .map(ct0 => {
            const category = ds[t0].cate[ct0]
            const campaigns = Object.keys(category.campaign).sort((cp1, cp2) => {
                const sortField = sortIdx[sort.field]
                const val1 = category.campaign[cp1][sortField]
                const val2 = category.campaign[cp2][sortField]
                let diff

                if (isNaN(val1) || isNaN(val2)) {
                    diff = (val1 ? '' + val1 : '').localeCompare(val2 ? '' + val2 : '')
                } else {
                    diff = val1 - val2
                }

                return sort.direction === "asc" ? diff : diff * -1
            }).map(cp0 => {
                const campaign = category.campaign[cp0]

                const agents = Object.keys(campaign.agent).sort((ag1, ag2) => {
                    return campaign.agent[ag2].totalLead - campaign.agent[ag1].totalLead
                }).map(ag0 => {
                    const agent = campaign.agent[ag0]

                    return agent
                })

                return [campaign, ...agents]
                // return agent
            }).reduce((prAg, nxAg) => prAg.concat(nxAg))

            return [category, ...campaigns]
        }).reduce((prCt, nxCt) => prCt.concat(nxCt))
}

export { callTeamTodayReport, buildHierarchy, sumHierarchy, callTeamTodayByCreatedateReport, extractTeamCampaign, calcHierarchy, calcHierarchyEle }